import { create } from "zustand";
const STORAGE_KEY = "side-menu-state";
const getStoredState = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        isOpen: parsed.isOpen ?? true,
        expandedMenus: parsed.expandedMenus ?? []
      };
    }
  } catch (error) {
    console.warn("Failed to load side menu state from localStorage:", error);
  }
  return {
    isOpen: true,
    expandedMenus: []
    // 처음에는 모든 메뉴가 닫혀있음
  };
};
const saveState = (state) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.warn("Failed to save side menu state to localStorage:", error);
  }
};
const menuStore = create((set, get) => {
  const initialState = getStoredState();
  return {
    ...initialState,
    toggleMenuOpen: () => {
      set((state) => {
        const newState = { ...state, isOpen: !state.isOpen };
        saveState(newState);
        return newState;
      });
    },
    closeMenu: () => {
      set((state) => {
        const newState = { ...state, isOpen: false };
        saveState(newState);
        return newState;
      });
    },
    openMenu: () => {
      set((state) => {
        const newState = { ...state, isOpen: true };
        saveState(newState);
        return newState;
      });
    },
    toggleExpandedMenu: (menuId) => {
      set((state) => {
        const newExpandedMenus = state.expandedMenus.includes(menuId) ? state.expandedMenus.filter((id) => id !== menuId) : [...state.expandedMenus, menuId];
        const newState = { ...state, expandedMenus: newExpandedMenus };
        saveState(newState);
        return newState;
      });
    },
    setExpandedMenu: (menuId, isExpanded) => {
      set((state) => {
        const newExpandedMenus = isExpanded ? [...state.expandedMenus, menuId] : state.expandedMenus.filter((id) => id !== menuId);
        const newState = { ...state, expandedMenus: newExpandedMenus };
        saveState(newState);
        return newState;
      });
    },
    clearExpandedMenus: () => {
      set((state) => {
        const newState = { ...state, expandedMenus: [] };
        saveState(newState);
        return newState;
      });
    },
    isExpanded: (menuId) => get().expandedMenus.includes(menuId),
    initializeExpandedMenus: (menuIds) => {
      set((state) => {
        if (state.expandedMenus.length === 0) {
          const newState = { ...state, expandedMenus: menuIds };
          saveState(newState);
          return newState;
        }
        return state;
      });
    }
  };
});
const useMenuStore = menuStore;
export {
  useMenuStore
};
